import { render, staticRenderFns } from "./edit-user-overlay.vue?vue&type=template&id=2962d694"
import script from "./edit-user-overlay.vue?vue&type=script&lang=js"
export * from "./edit-user-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports